
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Tooltip2248153852",
      {"classes":{"root":"Tooltip2248153852__root","tpaArrow":"Tooltip2248153852__tpaArrow","withArrow":"Tooltip2248153852__withArrow","popoverAnimation-enter":"Tooltip2248153852__popoverAnimation-enter","popoverAnimation-enter-active":"Tooltip2248153852__popoverAnimation-enter-active","popoverAnimation-exit":"Tooltip2248153852__popoverAnimation-exit","popoverAnimation-exit-active":"Tooltip2248153852__popoverAnimation-exit-active"},"vars":{"wix-color-1":"--wix-color-1","wix-color-5":"--wix-color-5","wix-ui-tpa-tooltip-background-color":"--wix-ui-tpa-tooltip-background-color","wix-ui-tpa-tooltip-text-color":"--wix-ui-tpa-tooltip-text-color","wix-ui-tpa-tooltip-border-color":"--wix-ui-tpa-tooltip-border-color"},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  